module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movie-details-page"
  }, [(_vm.prerender) ? _c('div', [_c('div', {
    staticClass: "detail-movie__header-img"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.standard && _vm.movie.images.standard.banner.url),
      expression: "movie.images.standard && movie.images.standard.banner.url"
    }]
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.standard.banner.url),
      expression: "movie.images.standard.banner.url"
    }],
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.standard.banner.url,
      "alt": _vm.movie.images.standard.banner.alt
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.featured.banner && _vm.movie.featured.banner.url),
      expression: "movie.featured.banner && movie.featured.banner.url"
    }]
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.featured.banner.url),
      expression: "movie.images.featured.banner.url"
    }],
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.featured.banner.url,
      "alt": _vm.movie.images.featured.banner.alt
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.movie.featured.banner && !_vm.movie.images.standard),
      expression: "!movie.featured.banner && !movie.images.standard"
    }]
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/movie-summary-default-bg.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-container', {
    staticClass: "detail-movie__info"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.hasPromos && _vm.movie.images.promo && _vm.movie.images.promo.banner.url),
      expression: "movie.hasPromos && movie.images.promo && movie.images.promo.banner.url"
    }],
    staticClass: "detail-movie__info-promo"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.promo.banner.url,
      "alt": _vm.movie.images.promo.alt
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.hasEvents && _vm.movie.images.event && _vm.movie.images.event.banner.url),
      expression: "movie.hasEvents && movie.images.event && movie.images.event.banner.url"
    }],
    staticClass: "detail-movie__info-event"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.event.banner.url,
      "alt": _vm.movie.images.event.alt
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "movie-detail"
  }, [_c('sk-panel', [_c('sk-layout', {
    class: (!_vm.$breakpoints.xs ? 'gutter-40' : ''),
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs5": "",
      "sm4": "",
      "md3": "",
      "lg2": ""
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogActive = true
      }
    }
  }, [_c('div', {
    staticClass: "movie-detail__poster-img"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.poster,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-icon', {
    staticClass: "movie-detail__poster-play",
    attrs: {
      "play": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-video', {
    staticClass: "dialog-video",
    attrs: {
      "content": _vm.movie.youtube_id
    },
    model: {
      value: (_vm.dialogActive),
      callback: function($$v) {
        _vm.dialogActive = $$v
      },
      expression: "dialogActive"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs7": "",
      "sm8": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('h3', {
    staticClass: "movie-detail__releasing"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.now_showing),
      expression: "movie.now_showing"
    }]
  }, [_vm._v("\n                                    Now Showing\n                                ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.movie.now_showing),
      expression: "!movie.now_showing"
    }]
  }, [_vm._v("\n                                    Releasing: " + _vm._s(_vm.movie.opening_date.additional.string_nth_day) + "\n                                    " + _vm._s(_vm.movie.opening_date.additional.string_long_month) + " " + _vm._s(_vm.movie.opening_date.additional.year) + "\n                                ")])]), _vm._v(" "), _c('h1', {
    staticClass: "movie-detail__title"
  }, [_vm._v("\n                                " + _vm._s(_vm.movie.title) + "\n                                "), _c('sk-social-share', {
    attrs: {
      "id": _vm.movie.id,
      "movie-title": _vm.movie.title,
      "twitter-text": "Let's go watch this movie at Ster-Kinekor!"
    }
  })], 1), _vm._v(" "), (_vm.$breakpoints.xs) ? _c('sk-button', {
    attrs: {
      "tertiary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialogActive = true
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "play-button": ""
    }
  }), _vm._v("\n                                Play Trailer\n                            ")], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs"
  }, [_c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.movie.rating))]), _vm._v(" "), _vm._l((_vm.movie.genres), function(genre) {
    return _c('span', {
      key: genre.id
    }, [_vm._v(_vm._s(genre.name))])
  }), _vm._v(" "), _c('span', [_vm._v("•\n                                        " + _vm._s(_vm.movie.runtime_hour_minute.hours) + "h " + _vm._s(_vm.movie.runtime_hour_minute.minutes) + "m")])], 2), _vm._v(" "), _c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_vm._l((_vm.movie.experiences), function(experience) {
    return [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(experience))])]
  }), _vm._v(" "), _vm._l((_vm.movie.flags), function(flags) {
    return [_c('span', {
      staticClass: "label "
    }, [_vm._v(_vm._s(flags))])]
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "movie-detail__synopsis "
  }, [_vm._v("\n                                    " + _vm._s(_vm._f("truncate")(_vm.movie.synopsis, _vm.truncAmount, '...')) + "\n                                    "), (_vm.movie.synopsis.length >= _vm.truncAmount) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.truncToggle($event.currentTarget)
      }
    }
  }, [_vm._v("\n                                        Read more\n                                    ")]) : _vm._e()], 1), _vm._v(" "), (_vm.movie.cast.actors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("ACTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.actors), function(actor, index) {
    return _c('span', [_vm._v(_vm._s(actor.FirstName) + " " + _vm._s(actor.LastName)), ((index + 1) < _vm.movie.cast.actors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.movie.cast.directors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("DIRECTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.directors), function(director, index) {
    return _c('span', [_vm._v(_vm._s(director.FirstName) + " " + _vm._s(director.LastName)), ((index + 1) < _vm.movie.cast.directors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.buttons) ? _c('div', {
    staticClass: "movie-detail__buttons"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("Book to win\n                                    ")])], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('sk-spacer')], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "visible-xs"
  }, [_c('sk-spacer', {
    attrs: {
      "height": "20"
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_c('span', {
    staticClass: "label label--invert"
  }, [_vm._v(_vm._s(_vm.movie.rating))]), _vm._v(" "), _vm._l((_vm.movie.genres), function(genre) {
    return _c('span', {
      key: genre.id
    }, [_vm._v(_vm._s(genre.name))])
  }), _vm._v(" "), _c('span', [_vm._v("• " + _vm._s(_vm.movie.runtime_hour_minute.hours) + "h " + _vm._s(_vm.movie.runtime_hour_minute.minutes) + "m")])], 2), _vm._v(" "), _c('div', {
    staticClass: "list-inline movie-detail__labels"
  }, [_vm._l((_vm.movie.experiences), function(experience) {
    return [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(experience))])]
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "movie-detail__synopsis"
  }, [_vm._v("\n                                " + _vm._s(_vm._f("truncate")(_vm.movie.synopsis, _vm.truncAmount, '...')) + "\n                                "), (_vm.movie.synopsis.length >= _vm.truncAmount) ? _c('sk-button', {
    attrs: {
      "link": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.truncToggle($event.currentTarget)
      }
    }
  }, [_vm._v("\n                                    Read more\n                                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.movie.cast.actors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("ACTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.actors), function(actor, index) {
    return _c('span', [_vm._v(_vm._s(actor.FirstName) + " " + _vm._s(actor.LastName)), ((index + 1) < _vm.movie.cast.actors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.movie.cast.directors.length > 0) ? [_c('div', {
    staticClass: "list-inline white--text"
  }, [_c('span', [_vm._v("DIRECTORS: ")]), _vm._v(" "), _vm._l((_vm.movie.cast.directors), function(director, index) {
    return _c('span', [_vm._v(_vm._s(director.FirstName) + " " + _vm._s(director.LastName)), ((index + 1) < _vm.movie.cast.directors.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.buttons) ? _c('div', {
    staticClass: "movie-detail__buttons"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'details',
        params: {
          id: _vm.movie.id
        }
      }
    }
  }, [_vm._v("Book to win\n                                ")])], 1) : _vm._e()], 2)], 1)], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.prerender) ? _c('div', {
    staticClass: "detail main-view--no-margin"
  }, [_c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showHandleGenericError),
      callback: function($$v) {
        _vm.showHandleGenericError = $$v
      },
      expression: "showHandleGenericError"
    }
  }, [_c('h3', [_vm._v("Oops, something went wrong")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.loadingContinue
    },
    nativeOn: {
      "click": function($event) {
        _vm.backToMovie()
      }
    }
  }, [_vm._v("Back to Movie")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v("Take me home")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.showHandleNoSeatsAvailableError),
      callback: function($$v) {
        _vm.showHandleNoSeatsAvailableError = $$v
      },
      expression: "showHandleNoSeatsAvailableError"
    }
  }, [_c('h3', [_vm._v("Oops, something went wrong")]), _vm._v(" "), _c('p', [_vm._v("There are no seats available for this time slot, please select another.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "loading": _vm.loadingContinue
    },
    nativeOn: {
      "click": function($event) {
        _vm.showHandleNoSeatsAvailableError = false;
        _vm.loading = false
      }
    }
  }, [_vm._v("Back to Movie")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        _vm.goHome()
      }
    }
  }, [_vm._v("Take me home")])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.movie && _vm.movie != undefined),
      expression: "!loading && movie && movie != undefined"
    }]
  }, [_c('div', {
    staticClass: "detail-movie__header-img"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.standard && _vm.movie.images.standard.banner.url),
      expression: "movie.images.standard && movie.images.standard.banner.url"
    }]
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.standard.banner.url),
      expression: "movie.images.standard.banner.url"
    }],
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.standard.banner.url,
      "alt": _vm.movie.images.standard.banner.alt
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.featured.banner && _vm.movie.featured.banner.url),
      expression: "movie.featured.banner && movie.featured.banner.url"
    }]
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.images.featured.banner.url),
      expression: "movie.images.featured.banner.url"
    }],
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.featured.banner.url,
      "alt": _vm.movie.images.featured.banner.alt
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.movie.featured.banner && !_vm.movie.images.standard),
      expression: "!movie.featured.banner && !movie.images.standard"
    }]
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/movie-summary-default-bg.jpg",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-container', {
    staticClass: "detail-movie__info"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.hasPromos && _vm.movie.images.promo && _vm.movie.images.promo.banner.url),
      expression: "movie.hasPromos && movie.images.promo && movie.images.promo.banner.url"
    }],
    staticClass: "detail-movie__info-promo"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.promo.banner.url,
      "alt": _vm.movie.images.promo.alt
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.movie.hasEvents && _vm.movie.images.event && _vm.movie.images.event.banner.url),
      expression: "movie.hasEvents && movie.images.event && movie.images.event.banner.url"
    }],
    staticClass: "detail-movie__info-event"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.movie.images.event.banner.url,
      "alt": _vm.movie.images.event.alt
    }
  })]), _vm._v(" "), _c('sk-movie-detail', {
    attrs: {
      "movie": _vm.movie
    }
  })], 1), _vm._v(" "), (_vm.movie.has_sessions_available) ? _c('sk-container', [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "detail-start-booking"
  }, [_vm._v("Start your booking")]), _vm._v(" "), _c('div', {
    staticClass: "detail-cinema"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.selectedCinemaId) ? _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Cinema")])]) : _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Cinema")])]), _vm._v(" "), (_vm.selectedCinemaId && !_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Cinema Type")])]) : _vm._e(), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('sk-google-places-input', {
    ref: "location_input",
    staticClass: "location-search",
    attrs: {
      "placeholder": "Seach location",
      "geolocation": "",
      "autocomplete": "",
      "pinOnly": ""
    },
    on: {
      "place-selected": _vm.placeSelected
    },
    model: {
      value: (_vm.formData.place_query),
      callback: function($$v) {
        _vm.$set(_vm.formData, "place_query", $$v)
      },
      expression: "formData.place_query"
    }
  }), _vm._v(" "), _c('sk-multi-select-regions', {
    staticClass: "cinema-select form-group",
    attrs: {
      "val": _vm.formData.cinema,
      "items": _vm.regions
    },
    model: {
      value: (_vm.formData.cinema),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cinema", $$v)
      },
      expression: "formData.cinema"
    }
  })], 1) : _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-google-places-input', {
    ref: "location_input",
    staticClass: "location-search",
    attrs: {
      "placeholder": "Seach location",
      "geolocation": "",
      "autocomplete": "",
      "pinOnly": ""
    },
    on: {
      "place-selected": _vm.placeSelected
    },
    model: {
      value: (_vm.formData.place_query),
      callback: function($$v) {
        _vm.$set(_vm.formData, "place_query", $$v)
      },
      expression: "formData.place_query"
    }
  }), _vm._v(" "), _c('sk-multi-select-regions', {
    staticClass: "cinema-select form-group",
    attrs: {
      "val": _vm.formData.cinema,
      "items": _vm.regions
    },
    model: {
      value: (_vm.formData.cinema),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cinema", $$v)
      },
      expression: "formData.cinema"
    }
  })], 1), _vm._v(" "), (_vm.selectedCinemaId && _vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Cinema Type")])]) : _vm._e(), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [(_vm.formData.cinema) ? _c('sk-multi-select-types', {
    staticClass: "cinema-select form-group",
    attrs: {
      "val": _vm.formData.experienceName,
      "items": _vm.typesForCinemas,
      "multiple": false
    },
    model: {
      value: (_vm.formData.experienceName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "experienceName", $$v)
      },
      expression: "formData.experienceName"
    }
  }) : _vm._e()], 1) : _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.formData.cinema) ? _c('sk-multi-select-types', {
    staticClass: "cinema-select form-group",
    attrs: {
      "val": _vm.formData.experienceName,
      "items": _vm.typesForCinemas,
      "multiple": false
    },
    model: {
      value: (_vm.formData.experienceName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "experienceName", $$v)
      },
      expression: "formData.experienceName"
    }
  }) : _vm._e()], 1)], 1)], 1)])], 1), _vm._v(" "), (_vm.selectedCinemaId && _vm.availableDates != undefined && _vm.availableDates != null) ? _c('div', {
    staticClass: "detail-movie-select-date",
    attrs: {
      "id": "select-date-time"
    }
  }, [(_vm.availableDates.length > 0) ? [_c('hr'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a Date and Time")]), _vm._v(" "), (_vm.availableDates.length <= 6 && !_vm.$breakpoints.xs) ? [(_vm.availableDates.length > 0) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.availableDates), function(session, index) {
    return _c('sk-flex', {
      key: session.id,
      attrs: {
        "sm2": "",
        "md2": "",
        "lg2": "",
        "grow": ""
      }
    }, [(session != undefined && session != null) ? [
      [((session.show_time.additional.day == '01' || index == 0)) ? _c('div', {
        staticClass: "label__month"
      }, [(_vm.$breakpoints.smDown) ? [_vm._v("\n                                                        " + _vm._s(session.show_time.additional.string_short_month) + "\n                                                    ")] : [_vm._v("\n                                                        " + _vm._s(session.show_time.additional.string_long_month) + "\n                                                    ")], _vm._v("\n                                                    " + _vm._s(session.show_time.additional.year) + "\n\n                                                ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
        ref: "session_time",
        refInFor: true,
        staticClass: "label label--lg",
        class: {
          active: _vm.compareDates(session.show_time.date, _vm.sessionData.selectedDate), 'btn-mask': true, 'disabled': !_vm.getStatus(session)
        },
        attrs: {
          "id": session.id
        },
        on: {
          "click": function($event) {
            _vm.setSelectedDate(session.show_time.date);
          }
        }
      }, [_c('div', {
        staticClass: "detail-movie-select-date--date"
      }, [_c('div', {
        staticClass: "detail-movie-select-date--day"
      }, [_vm._v("\n                                                                " + _vm._s(session.show_time.additional.day) + "\n                                                            ")]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-date--month"
      }, [_vm._v("\n                                                                " + _vm._s(session.show_time.additional.string_long_day_of_week) + "\n                                                            ")])])])]
    ] : _vm._e()], 2)
  })) : _vm._e()] : [_c('sk-carousel', {
    attrs: {
      "slides-per-page": (_vm.$breakpoints.xs ? 3 : 6)
    }
  }, _vm._l((_vm.availableDates), function(session, index) {
    return _c('div', {
      key: session.id,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [(session != undefined && session != null) ? [(session.show_time != undefined && session.show_time != null) ? [((session.show_time.additional.day == '01' || index == 0)) ? _c('div', {
      staticClass: "label__month"
    }, [(_vm.$breakpoints.smDown) ? [_vm._v("\n                                                        " + _vm._s(session.show_time.additional.string_short_month) + "\n                                                    ")] : [_vm._v("\n                                                        " + _vm._s(session.show_time.additional.string_long_month) + "\n                                                    ")], _vm._v("\n                                                    " + _vm._s(session.show_time.additional.year) + "\n\n                                                ")], 2) : _vm._e(), _vm._v(" "), _c('div', {
      ref: "session_time",
      refInFor: true,
      staticClass: "label label--lg",
      class: {
        active: _vm.compareDates(session.show_time.date, _vm.sessionData.selectedDate), 'btn-mask': true, 'disabled': !_vm.getStatus(session)
      },
      attrs: {
        "id": session.id
      },
      on: {
        "click": function($event) {
          _vm.setSelectedDate(session.show_time.date);
        }
      }
    }, [_c('div', {
      staticClass: "detail-movie-select-date--date"
    }, [_c('div', {
      staticClass: "detail-movie-select-date--day"
    }, [_vm._v("\n                                                            " + _vm._s(session.show_time.additional.day) + "\n                                                        ")]), _vm._v(" "), _c('div', {
      staticClass: "detail-movie-select-date--month"
    }, [_vm._v("\n                                                            " + _vm._s(session.show_time.additional.string_short_day_of_week) + "\n                                                        ")])])])] : _vm._e()] : _vm._e()], 2)
  }))], _vm._v(" "), (_vm.sessionData.selectedDate) ? _c('div', {
    staticClass: "detail-movie-select-time",
    class: (_vm.availableSessions.length >= 6) ? 'carousel' : ''
  }, [(_vm.availableSessions.length <= 6 && !_vm.$breakpoints.xs) ? [_c('sk-layout', _vm._l((_vm.availableSessions), function(session) {
    return _c('sk-flex', {
      key: session.id,
      attrs: {
        "wrap": ""
      }
    }, [(session != undefined && session != null) ? [
      [(_vm.matching_time_tags.includes(session.time_tag)) ? _c('span', {
        ref: "session_time",
        refInFor: true,
        staticClass: "active label label--lg",
        class: {
          active: session == _vm.sessionData.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
        },
        attrs: {
          "id": session.id
        },
        on: {
          "click": function($event) {
            _vm.setSelectedSession(session);
          }
        }
      }, [_c('div', {
        staticClass: "detail-movie-select-time--time"
      }, [_vm._v(_vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute))]), _vm._v(" "), (_vm.getStatusString(session) == 'Sold Out') ? [_c('div', {
        staticClass: "detail-movie-select-time--info sold-out-label"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)))])] : [_c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)))])], _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')))])], 2) : _c('span', {
        ref: "session_time",
        refInFor: true,
        staticClass: "label label--lg not-selected",
        class: {
          active: session == _vm.sessionData.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
        },
        attrs: {
          "id": session.id
        },
        on: {
          "click": function($event) {
            _vm.setSelectedSession(session);
          }
        }
      }, [_c('div', {
        staticClass: "detail-movie-select-time--time"
      }, [_vm._v(_vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute))]), _vm._v(" "), (_vm.getStatusString(session) == 'Sold Out') ? [_c('div', {
        staticClass: "detail-movie-select-time--info sold-out-label"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)))])] : [_c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)))])], _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')))])], 2)]
    ] : _vm._e()], 2)
  }))] : [_c('sk-carousel', {
    attrs: {
      "data": _vm.availableSessions,
      "slides-per-page": (_vm.$breakpoints.xs ? 3 : 6)
    }
  }, _vm._l((_vm.availableSessions), function(session) {
    return _c('div', {
      key: session.id,
      staticClass: "slide",
      attrs: {
        "slot": "slides"
      },
      slot: "slides"
    }, [(session != undefined && session != null) ? [
      [(_vm.matching_time_tags.includes(session.time_tag)) ? _c('div', {
        ref: "session_time",
        refInFor: true,
        staticClass: "active label label--lg",
        class: {
          active: session == _vm.sessionData.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
        },
        attrs: {
          "id": session.id
        },
        on: {
          "click": function($event) {
            _vm.setSelectedSession(session);
          }
        }
      }, [_c('div', {
        staticClass: "detail-movie-select-time--time"
      }, [_vm._v("\n                                                            " + _vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute) + "\n                                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)) + "\n                                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v("\n                                                            " + _vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')) + "\n                                                        ")])]) : _c('div', {
        ref: "session_time",
        refInFor: true,
        staticClass: "label label--lg",
        class: {
          active: session == _vm.sessionData.selectedSession, 'btn-mask': true, 'disabled': !_vm.getStatus(session)
        },
        attrs: {
          "id": session.id
        },
        on: {
          "click": function($event) {
            _vm.setSelectedSession(session);
          }
        }
      }, [_c('div', {
        staticClass: "detail-movie-select-time--time"
      }, [_vm._v("\n                                                            " + _vm._s(session.show_time.additional.no_zero_hour_24) + ":" + _vm._s(session.show_time.additional.minute) + "\n                                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(_vm.getStatusString(session)) + "\n                                                        ")]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v(_vm._s(session.screen_name))]), _vm._v(" "), _c('div', {
        staticClass: "detail-movie-select-time--info"
      }, [_vm._v("\n                                                            " + _vm._s(session.experiences.map(function (e) { return e.name; }).join(', ')) + "\n                                                        ")])])]
    ] : _vm._e()], 2)
  }))]], 2) : _vm._e()] : _vm._e()], 2) : (_vm.selectedCinemaId && _vm.availableDates != undefined && _vm.availableDates != null) ? _c('div', [(_vm.availableDates.length == 0) ? [_vm._v("\n                            Whoops, it seems we can't find any shows for based on your current filter, please select a Cinema type to find shows.\n                        ")] : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), _c('sk-signin', {
    ref: "signUp",
    attrs: {
      "signUp": _vm.signUp
    },
    on: {
      "changed": _vm.toggleSignUp
    }
  }), _vm._v(" "), (!_vm.festival && _vm.related_movies) ? _c('sk-related-movies', {
    attrs: {
      "movies": _vm.related_movies
    }
  }) : (_vm.festival && _vm.festival.Movies.length > 0) ? _c('sk-related-movies', {
    attrs: {
      "label": ("Other Movies For: " + (_vm.festival.title) + " "),
      "link": ("/film-festival-details/" + (_vm.festival.nid)),
      "movies": _vm.festival.Movies.filter(function (m) { return m.id !== _vm.$route.params.id; })
    }
  }) : _vm._e()], 1) : _c('sk-container', [_c('sk-panel', [_c('p', [_vm._v("Excited to see this movie? Hold tight, bookings will be available soon.")])])], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6729ca77","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/details/details.vue
// module id = 541
// module chunks = 0